import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import VehicleDetails from "./VehicleDetails";
import VehicleDetailPagination from "./VehicleDetailPagination";
import { APIUtility } from "../../Api";
import Pagination from "../../components/Common/Pagination";

const VehicleData = () => {
  const [vehicleNoData, setVehicleNoData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState([]);
  const[serachQuery,setSearchQuery]=useState("")
  const getVehicleNoData = async (page,search_vehicle_no) => {
    try {
      setIsLoading(true);
      const res = await APIUtility.getVehicleNoData({ page,search_vehicle_no});

      if (res.status == 200) {
        setVehicleNoData(res.data?.serialized_data);
        setPaginationData(res.data?.pagination_details);
        setIsLoading(false);
      } else {
        setVehicleNoData([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error, "error");
      setVehicleNoData([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getVehicleNoData(currentPage,'');
  }, []);

  return (
    <div className="p-6 pb-0">
      <div className="mb-[10px] w-full flex justify-between">
        <div className="text-gray-400 text-lg font-semibold">
          Vehicles and Details
        </div>
        <div className="relative flex items-center">
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 pointer-events-none"
            color="#999999"
          />
          <input
            type="text"
            placeholder="Search Vehicle No."
            className="pl-10 pr-4 py-2 border rounded w-[415px] h-[45px]"
            style={{ paddingLeft: "2.5rem" }}
            value={serachQuery}
            onChange={(e)=>{setSearchQuery(e.target.value)
              setCurrentPage(1)
              getVehicleNoData(1,e.target.value);
            }}
          />
        </div>
      </div>
      <VehicleDetails
        data={vehicleNoData ? vehicleNoData : []}
        isLoading={isLoading}
      />
      <div className=" w-full flex items-center justify-center pt-[5.5px]">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={paginationData?.count || 10}
          pageSize={10}
          onPageChange={(page) => {
            setCurrentPage(page);
            getVehicleNoData(page);
          }}
        />
      </div>
    </div>
  );
};

export default VehicleData;
